import VueChartJS from 'vue-chartjs'
import ChartJSDatalabels from 'chartjs-plugin-datalabels'
import Chart from 'chart.js'
import Basic from '@/components/page/Basic.js'

Chart.plugins.register(ChartJSDatalabels)

Chart.defaults.MyLine = Chart.defaults.line;
Chart.controllers.MyLine = Chart.controllers.line.extend({
   draw: function(ease) {
      Chart.controllers.line.prototype.draw.call(this, ease);

      if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
         var activePoint = this.chart.tooltip._active[0],
             ctx = this.chart.ctx,
             x = activePoint.tooltipPosition().x,
             topY = this.chart.scales['y-axis-0'].top,
             bottomY = this.chart.scales['y-axis-0'].bottom

         // draw line
         ctx.save();
         ctx.beginPath();
         ctx.moveTo(x, topY);
         ctx.lineTo(x, bottomY);
         ctx.lineWidth = 2;
         ctx.strokeStyle = 'rgba(0,119,204,.95)';
         ctx.stroke();
         ctx.restore();

      }
   }
});

// Definisikan formatNum di luar objek Vue
function formatNum(value, afterComma = 2) {
    if (typeof value !== "number" || value == "undefined" || value == "NaN") {
        // return value;
    }

	/*
    var formatter = new Intl.NumberFormat('en-ID', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: afterComma
    });
	*/

	var formatter = new Intl.NumberFormat('id-ID', {
		//style: 'currency',
		style: 'decimal',
		currency: 'IDR',
		minimumFractionDigits: afterComma, //0
		maximumFractionDigits: afterComma //0
	});

    let cleanValue = value;
    if (value !== null)
        cleanValue = value.toString().replace(',', '.');

    return formatter.format(cleanValue).replace('$', '');
}

export default {
	extends:VueChartJS.Bar,
	mixins:VueChartJS.mixins.reactiveData,
	//props:["data","page","url","tooltipaftertitle", "totalValue"],
	props: {
		data: [],
		page: 0,
		url: '',
		tooltipaftertitle: [],
		totalValue: '',
		disable: false,
		showlegend: {
			type: Boolean,
			default: true
		},
		legendPosition: {
            type: String,
            default: 'bottom'
        },
        toggleLegend: {
            type: Boolean, // Nilai: "checkAll" atau "uncheckAll"
            default: true
        },
	},

	components:{
	},

	methods:{
		handleclickchart(){
			if(this.url)window.open(this.url,'_blank')
		},
		redraw() {
			let data1 = this.data
			let tooltipaftertitle = this.tooltipaftertitle;
			let totalValue = this.totalValue;
			//let legendPosition = this.legendPosition;
			var options={
				responsive:true,
				maintainAspectRatio:false,
				onClick:this.handleclickchart,
				tooltips:{
					enabled: true,
					intersect:false,
					mode:'label', //index
					callbacks: {

						label: function(tooltipItem, data) {
							//let label = data.labels[tooltipItem.index];
							var dstLabel = data.datasets[tooltipItem.datasetIndex].label;
							//var yLabel = tooltipItem.yLabel;
							return dstLabel +': '+tooltipItem.yLabel.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
						},
						beforeTitle: function(context){
							return null;//'before the title';
						},
						afterTitle: function(context) {
							let index = context[0].index;
							let label = context[0].label;
							let val = context[0].value;

							//console.log("index: "+JSON.stringify(context));
							//console.log("index: "+index);
							//console.log("label: "+label);
							//console.log("tooltip: "+JSON.stringify(this.tooltipaftertitle));

							if (typeof tooltipaftertitle !== "undefined" && tooltipaftertitle.length > 0) {
								return tooltipaftertitle[index];
							}

							return null;//`${test}`;//'after the title';
						},
						beforeBody: function(context) {
							return null;//'Before body';
						},
							beforeLabel: function(context) {
								return null;//'Before label';
							},/*
							label: function(context) {
								return "SAMPLE LABEL";
							},*/
							afterLabel: function(context) {
								return null;//'After label';
							},
						afterBody: function(context) {
							return null; //'After body'; //null;
						},
						beforeFooter: function(context) {
							return null;//'Before footer';
						},
						afterFooter: function(context) {
							//console.log('total: ' + JSON.stringify(context));

							let totalSum = context.map(item => item.value).reduce((prev, next) => parseFloat(prev) + parseFloat(next));
							//console.log('totalValue: ' + totalValue)

							if(totalValue == undefined || totalValue =='') {
								//set default
								//console.log('undefined total value')
							} else {
								totalSum = totalValue
							}
							//console.log('totalSum: ' + totalSum)
							//return 'Total: '+totalSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); //.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2});//.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'); //null;//'After footer';
							return 'TOTAL: '+ formatNum(totalSum)
						},
					},
					/*
					custom: function(tooltipModel) {
						// Tooltip Element
						let tooltipEl = document.getElementById('chartjs-tooltip');

						// Create element on first render
						if (!tooltipEl) {
							tooltipEl = document.createElement('div');
							tooltipEl.id = 'chartjs-tooltip';
							tooltipEl.innerHTML = '<table style="background-color:red;"></table>';
							document.body.appendChild(tooltipEl);
						}

						// Hide if no tooltip
						//const tooltipModel = context.tooltip;
						if (tooltipModel.opacity === 0) {
							tooltipEl.style.opacity = 0;
							return;
						}

						// Set caret Position
						tooltipEl.classList.remove('above', 'below', 'no-transform');
						if (tooltipModel.yAlign) {
							tooltipEl.classList.add(tooltipModel.yAlign);
						} else {
							tooltipEl.classList.add('no-transform');
						}

						function getBody(bodyItem) {
							return bodyItem.lines;
						}

						// Set Text
						if (tooltipModel.body) {
							const titleLines = tooltipModel.title || [];
							const bodyLines = tooltipModel.body.map(getBody);

							let innerHtml = '<thead>';

							titleLines.forEach(function(title) {
								innerHtml += '<tr><th height="10px">' + title + '</th></tr>';
							});
							innerHtml += '</thead><tbody>';

							bodyLines.forEach(function(body, i) {
								const colors = tooltipModel.labelColors[i];
								let style = 'background:' + colors.backgroundColor;
								style += '; border-color:' + colors.borderColor;
								style += '; border-width: 2px';
								const span = '<span style="' + style + '">' + body + '</span>';
								innerHtml += '<tr><td>' + span + '</td></tr>';
							});
							innerHtml += '</tbody>';

							let tableRoot = tooltipEl.querySelector('table');
							tableRoot.innerHTML = innerHtml;
						}

						const position = this._chart.canvas.getBoundingClientRect();
						//const bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);

						// Display, position, and set styles for font
						tooltipEl.style.opacity = 1;
						tooltipEl.style.position = 'absolute';
						tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
						tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
						//tooltipEl.style.font = bodyFont.string;
						tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
						tooltipEl.style.pointerEvents = 'none';
					}*/

				},

				legend:{
                    display:this.showlegend,
                    position:this.legendPosition,
                    datalabels:{font:{size:8}},
                    labels: {
                        font: {
                            size: 8
                        },
                        usePointStyle: false, // Opsional, membuat bentuk legend lebih menarik
                    },
                    onHover: (event, legendItem) => {
                        const datasetIndex = legendItem.datasetIndex;
                        const chart = this.$data._chart;

                        // Ubah cursor menjadi pointer saat hover di legend
                        //event.native.target.style.cursor = "pointer";
                        chart.canvas.style.cursor = "pointer";
                        /*
                        chart.data.datasets.forEach((dataset, index) => {
                            dataset.backgroundColor = index === datasetIndex
                                ? dataset.originalBackgroundColor
                                : 'rgba(0, 0, 0, 0.1)'; // Membuat dataset lain transparan
                        });
                        */
                        //chart.update();

                    },
                    onLeave: (event) => {
                        const chart = this.$data._chart;

                        // Kembalikan cursor ke default setelah leave
                        //event.native.target.style.cursor = "default";
                        chart.canvas.style.cursor = "default";
                        /*
                        chart.data.datasets.forEach(dataset => {
                            dataset.backgroundColor = dataset.originalBackgroundColor;
                        });

                        chart.update();
                        */
                    }
                },
				scales:{
					yAxes:[
						{
							gridLines:{
								display:true,borderDash:[10],color:'rgba(0,0,255,.25)',
							},
							ticks: {
								beginAtZero:true,
								display:true,
								/*
								callback: function(value, index) {
									const valueLegend = this.getLabelForValue(value);
									return valueLegend + 'K';
								}, */
								callback: function(value, index, values) {
									if(value >= 1000000000 ) {
										let legend = value/1000000000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' M';
									}

									if(value >= 1000000 ) {
										let legend = value/1000000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' J';
									}

									if(value >= 100000) {
										let legend = value/1000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' K';
									}

									//below 0
									if(value <= -1000000000) {
										let legend = value/1000000000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' M';
									}

									if(value <= -1000000) {
										let legend = value/1000000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' J';
									}

									if(value <= -100000) {
										let legend = value/1000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' K';
									}

									return value;

								},

							}
						}
					],
					xAxes:[{gridLines:{display:true,borderDash:[10],color:'rgba(255,0,0,.25)',},
						ticks: {
							beginAtZero:true,
							display:true,

						}}
					],
				},
				plugins: {
					datalabels: {
						display:false,
						borderRadius:function(){ return '15px' },
						backgroundColor:()=>'#ff0000',
						color: '#555'
					},


				},
				layout: {
					padding: {
						top: 30
					}
				},

			}
			this.addPlugin(ChartJSDatalabels)
			this.renderChart(data1, options)
		},
        checkAllLegend() {
            const chart = this.$data._chart;
            chart.data.datasets.forEach(dataset => {
                dataset.hidden = false;
            });
            //chart.update();
          },

        // Method untuk menyembunyikan semua dataset (uncheck all)
        uncheckAllLegend() {
            const chart = this.$data._chart;
            chart.data.datasets.forEach(dataset => {
                dataset.hidden = true;
            });
            //chart.update();
        },
	},

	mounted() {
		this.redraw();
	},

	watch: {
		data: function() {
			this.redraw();
		},
        // Watch untuk prop toggleLegend
        toggleLegend(newVal) {
            if (newVal === true) {
                this.checkAllLegend();
            } else {
                this.uncheckAllLegend();
            }
        }
	}
}
